export const availableLanguages = ['en', 'ga'] as const;

export const dayjsLocaleMapping = {
  en: 'en-ie',
  ga: 'ga',
} as const;
